import { Model } from "../base/model";

export class Home extends Model {
  constructor(params: any = {}) {
    super(params);
    this.name = "Home";
  }

  async getHomeData(answeredDate?: string): Promise<any> {
    this.url = "/cms/api/home/get-dashboard-info";
    this.reqParams = answeredDate ? { answeredDate } : {};
    return await this.fetch();
  }

  async recordDailyCondition(params: any): Promise<any> {
    this.url = "/cms/api/home/record-user-daily-conditions";
    return await this.save(params, "POST");
  }

  async recordDailyNotes(params: any): Promise<any> {
    this.url = "/cms/api/home/user-daily-notes";
    return await this.save(params, "POST");
  }

  async recordDailyFeeling(params: any): Promise<any> {
    this.url = "/cms/api/home/user-daily-feeling";
    return await this.save(params, "POST");
  }

  async hasNewNotice(): Promise<any> {
    this.url = "/cms/api/home/get-new-notifications";
    return await this.fetch();
  }

  async setDailyNoteHiddenFlag(): Promise<any> {
    this.url = "/cms/api/home/set-daily-note-hidden-flag";
    return await this.save({}, "POST");
  }

  async setTodayConditionHiddenFlag(): Promise<any> {
    this.url = "/cms/api/home/set-today-condition-hidden-flag";
    return await this.save({}, "POST");
  }

  async setSymptomHiddenFlag(): Promise<any> {
    this.url = "/cms/api/home/set-symptom-hidden-flag";
    return await this.save({}, "POST");
  }
}
